import * as Yup from 'yup'
import { IListApiRequest } from 'api/types'
import { FacebookBusinessResponse, FBListParams } from './types'

export enum Channel {
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP',
  INAPP = 'INAPP'
}
export enum CHANNEL_FORM_FIELDS {
  NAME = 'name',
  DESCRIPTION = 'businessInfo',
  SENDERID = 'senderId',
  USERACCESSTOKEN = 'userAccessToken',
  DLTTEMPLATEID = 'dltTemplateId',
  CHANNEL = 'channel'
}

export interface AppChannelForm {
  [CHANNEL_FORM_FIELDS.NAME]: string;
  [CHANNEL_FORM_FIELDS.DESCRIPTION]: string;
  [CHANNEL_FORM_FIELDS.SENDERID]: string;
  [CHANNEL_FORM_FIELDS.USERACCESSTOKEN]: string;
  [CHANNEL_FORM_FIELDS.DLTTEMPLATEID]: string;
  [CHANNEL_FORM_FIELDS.CHANNEL]: Channel;
}

export const defaultAppChannelFormValues: AppChannelForm = {
  [CHANNEL_FORM_FIELDS.NAME]: '',
  [CHANNEL_FORM_FIELDS.DESCRIPTION]: '',
  [CHANNEL_FORM_FIELDS.SENDERID]: '',
  [CHANNEL_FORM_FIELDS.DLTTEMPLATEID]: '',
  [CHANNEL_FORM_FIELDS.USERACCESSTOKEN]: '',
  [CHANNEL_FORM_FIELDS.CHANNEL]: Channel.SMS
}

export const appChannelValidationSchema = Yup.object({
  [CHANNEL_FORM_FIELDS.NAME]: Yup.string().when(CHANNEL_FORM_FIELDS.CHANNEL, {
    is: (val: Channel) => val === Channel.INAPP || val === Channel.SMS,
    then: (schema) =>
      schema
        .required('App name is required')
        .min(3, 'App name must be at least 3 characters')
        .max(20, 'App name must be at most 20 characters'),
    otherwise: (schema) => schema.notRequired()
  }),

  [CHANNEL_FORM_FIELDS.DESCRIPTION]: Yup.string().when(
    CHANNEL_FORM_FIELDS.CHANNEL,
    {
      is: (val: Channel) => val === Channel.INAPP || val === Channel.SMS,
      then: (schema) =>
        schema
          .required('Description is required')
          .min(5, 'Business name must be at least 5 characters')
          .max(50, 'Business info must be at most 50 characters'),
      otherwise: (schema) => schema.notRequired()
    }
  ),
  [CHANNEL_FORM_FIELDS.SENDERID]: Yup.string().when(
    CHANNEL_FORM_FIELDS.CHANNEL,
    {
      is: Channel.SMS,
      then: (schema) => schema.required('Sender ID is required'),
      otherwise: (schema) => schema.notRequired()
    }
  ),

  [CHANNEL_FORM_FIELDS.USERACCESSTOKEN]: Yup.string().when(
    CHANNEL_FORM_FIELDS.CHANNEL,
    {
      is: Channel.SMS,
      then: (schema) => schema.required('User Access Token is required'),
      otherwise: (schema) => schema.notRequired()
    }
  ),

  [CHANNEL_FORM_FIELDS.DLTTEMPLATEID]: Yup.string().when(
    CHANNEL_FORM_FIELDS.CHANNEL,
    {
      is: Channel.SMS,
      then: (schema) => schema.required('DLT Template ID is required'),
      otherwise: (schema) => schema.notRequired()
    }
  )
})

export const getPaginationQueryParams = (
  request: IListApiRequest<FacebookBusinessResponse>
): FBListParams => {
  const { filters, page } = request
  const params: FBListParams = {
    size: page?.size,
    page: page?.number ? page.number - 1 : 0
  }
  if (filters && filters.length > 0) {
    filters.forEach(({ fieldName, fieldValue }) => {
      if (
        fieldValue === null ||
        fieldValue === undefined ||
        fieldValue === '' ||
        fieldValue === 'all'
      ) {
        delete params[fieldName]
      } else {
        params[fieldName] = fieldValue
      }
    })
  }

  return params
}
